"use strict";

// #region Token types

var _num = { type: "num" }, _regexp = { type: "regexp" }, _string = { type: "string" };
var _name = { type: "name" };
var _eof = { type: "eof" };
var _newline = { type: "newline" };
var _indent = { type: "indent" };
var _dedent = { type: "dedent" };

var _bracketL = { type: "[", beforeExpr: true }, _bracketR = { type: "]" }, _braceL = { type: "{", beforeExpr: true };
var _braceR = { type: "}" }, _parenL = { type: "(", beforeExpr: true }, _parenR = { type: ")" };
var _comma = { type: ",", beforeExpr: true }, _semi = { type: ";", beforeExpr: true };
var _colon = { type: ":", beforeExpr: true }, _dot = { type: "." }, _question = { type: "?", beforeExpr: true }, _eta = { type: "@", beforeExpr: true };

var _slash = { prec: 10, beforeExpr: true };
var _eq = { isAssign: true, beforeExpr: true };
var _assign = { isAssign: true, beforeExpr: true };
var _equality = { prec: 4, beforeExpr: true };
var _relational = { prec: 4, beforeExpr: true };
var _bitwiseOR = { prec: 5, beforeExpr: true };
var _bitwiseXOR = { prec: 6, beforeExpr: true };
var _bitwiseAND = { prec: 7, beforeExpr: true };
var _bitShift = { prec: 8, beforeExpr: true };
var _plusMin = { prec: 9, beforeExpr: true };
var _multiplyModulo = { prec: 10, beforeExpr: true };
var _floorDiv = { prec: 10, beforeExpr: true };
var _posNegNot = { prec: 11, prefix: true, beforeExpr: true };
var _bitwiseNOT = { prec: 11, prefix: true, beforeExpr: true };
var _exponentiation = { prec: 12, beforeExpr: true };

// #endregion

// #region constants

// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.
var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

// Whether a single character denotes a newline.
var newline = /[\n\r\u2028\u2029]/;

// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.
var lineBreak = /\r\n|[\n\r\u2028\u2029]/g;

// #endregion


// move out to sep file?

const ASCII_CODES = {
    NULL: 0,
    StartOfHeading: 1,
    StartOfText: 2,
    TAB: 9,
    NEW_LINE: 10,
    VERTICAL_TAB: 11,
    NEW_PAGE: 12,
    CARRIAGE_RETURN: 13,
    ESCAPE: 27,
    SPACE: 32,
    EXCLAMATION_POINT: 33,
    DOUBLE_QUOTE: 34,
    HASH: 35,
    DOLLAR: 36,
    PERCENTAGE: 37,
    AMPERSAND: 38,
    SINGLE_QUOTE: 39,
    LEFT_PARENTHESIS: 40,
    RIGHT_PARENTHESIS: 41,
    ASTERISK: 42,
    PLUS: 43,
    COMMA: 44,
    MINUS: 45,
    DOT: 46,
    FORWARD_SLASH: 47,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    COLON: 58,
    SEMI_COLON: 59,
    LESS_THAN: 60,
    EQUAL: 61,
    GREATER_THAN: 62,
    QUESTION_MARK: 63,
    AT: 64,
    UPPERCASE_A: 65,
    UPPERCASE_B: 66,
    UPPERCASE_C: 67,
    UPPERCASE_D: 68,
    UPPERCASE_E: 69,
    UPPERCASE_F: 70,
    UPPERCASE_G: 71,
    UPPERCASE_H: 72,
    UPPERCASE_I: 73,
    UPPERCASE_J: 74,
    UPPERCASE_K: 75,
    UPPERCASE_L: 76,
    UPPERCASE_M: 77,
    UPPERCASE_N: 78,
    UPPERCASE_O: 79,
    UPPERCASE_P: 80,
    UPPERCASE_Q: 81,
    UPPERCASE_R: 82,
    UPPERCASE_S: 83,
    UPPERCASE_T: 84,
    UPPERCASE_U: 85,
    UPPERCASE_V: 86,
    UPPERCASE_W: 87,
    UPPERCASE_X: 88,
    UPPERCASE_Y: 89,
    UPPERCASE_Z: 90,
    LEFT_BRACKET: 91,
    BACKSLASH: 92,
    RIGHT_BRACKET: 93,
    CARET: 94,
    UNDER_SCORE: 95,
    BACK_QUOTE: 96,
    LOWERCASE_A: 97,
    LOWERCASE_B: 98,
    LOWERCASE_C: 99,
    LOWERCASE_D: 100,
    LOWERCASE_E: 101,
    LOWERCASE_F: 102,
    LOWERCASE_G: 103,
    LOWERCASE_H: 104,
    LOWERCASE_I: 105,
    LOWERCASE_J: 106,
    LOWERCASE_K: 107,
    LOWERCASE_L: 108,
    LOWERCASE_M: 109,
    LOWERCASE_N: 110,
    LOWERCASE_O: 111,
    LOWERCASE_P: 112,
    LOWERCASE_Q: 113,
    LOWERCASE_R: 114,
    LOWERCASE_S: 115,
    LOWERCASE_T: 116,
    LOWERCASE_U: 117,
    LOWERCASE_V: 118,
    LOWERCASE_W: 119,
    LOWERCASE_X: 120,
    LOWERCASE_Y: 121,
    LOWERCASE_Z: 122,
    LEFT_BRACE: 123,
    VERTICAL_LINE: 124,
    RIGHT_BRACE: 125,
    TILDE: 126
};


Sk.Tokenizer = function (input) {

    // #region global variables to store tokenizer state

    // tracks information about all of the loaded and processed lines (not EVERY line, just the ones loaded)
    var overallContent = {
        content: "",
        /* This is the parsers state. `strict` indicates
           whether strict mode is on, and `overallContent.bracketNesting` tracks the level
           of nesting within brackets for implicit lint continuation.*/
        bracketNesting: 0,
        // which line is being processed
        currentLineNumber: 0,
        // all loaded overallContent.content string length
        totalLen: 0,
        // last produced token
        lastToken: undefined
    };

    // tracks currently processed loaded line(s) and token information
    var loadedContent = {
        // currently loaded overallContent.content string length
        inputLen: 0,
        // The current position of the tokenizer in the input.
        position: 0,
        // current single line
        currentLine: "",
        // keeps track of how many tokens were created already from the currently loaded overallContent.content
        processedTokenCounter: 0
    };

    // placeholder for currently processed token information
    var currentTokenInformation = {
        // The type and value of the current token. 
        //tokVal: "",
        tokType: _newline,
        // The start and end offsets of the current token.
        tokStart: undefined,
        tokEnd: undefined,
        // These hold objects containing the tokens start and end line/column pairs.
        tokStartLoc: undefined,
        tokEndLoc: undefined
    };


    // tracks tokenizer flags
    var flags = {
        /* Internal state for the tokenizer. To distinguish between division
           operators and regular expressions, it remembers whether the last
           token was one that is allowed to be followed by an expression.
           (If it is, a slash is probably a regexp, if it isn't it's a
           division operator. See the `parseStatement` function for a
           caveat.)*/
        tokRegexpAllowed: true,
        /* Used to signal to callers of `readWord1` whether the word
           contained any escape sequences. This is needed because words with
           escape sequences must not be interpreted as keywords.*/
        containsEsc: false,
        /* Determines whether tokenizer is dealing with multiline token cases or not.
           If yes, loading new line will not remove information of previously loaded overallContent.content.
           If no, loading new line will reset loaded information.*/
        isMultilineProcessing: false,
        // tracks if all lines were read
        isEOF: false
    };

    // tracks indent-dedent state
    var indentStack = {
        // Current indentation stack
        indent: [],

        // Number of dedent tokens left (i.e. if tokType == _dedent, dedentCount > 0)
        // Multiple dedent tokens are read in at once, but processed individually in readToken()
        dedentCount: 0,

        init: function () {
            this.indent = [];
            this.dedentCount = 0;
        },
        count: function () {
            return this.indent.length;
        },
        len: function (i) {
            if (typeof i === "undefined" || i >= this.indent.length) {
                i = this.indent.length - 1;
            }
            if (i < 0) {
                return 0;
            }

            return this.indent[i].length;
        },
        isIndent: function (s) {
            return this.indent.length === 0 || s.length > this.len();
        },
        isDedent: function (s) {
            return this.indent.length > 0 && s.length < this.len();
        },
        addIndent: function (s) {
            this.indent.push(s);
        },
        addDedent: function (s) {
            this.dedentCount = 0;
            for (var i = this.indent.length - 1; i >= 0 && s.length < this.indent[i].length; --i) {
                ++this.dedentCount;
            }
        },
        updateDedent: function () {
            this.dedentCount = this.count();
        },
        pop: function () {
            --this.dedentCount;
            this.indent.pop();
        },
        undoIndent: function () {
            this.pop();
        }
    };

    // #endregion 

    var loadNextLine = isFunction(input)
        ? wrapStringReadFunc(input)
        : createStringReadFunc(String(input));

    loadNextLine();
    skipSpace();

    return {
        getNextToken: getNextToken,
        jumpTo: jumpTo,
        getIndent: getIndent
    };

    // #region public functions

    function getNextToken(forceRegexp) {
        // read new line if already finished processing last one
        if (isEndOfLine(loadedContent.Position)) {
            loadNextLine();
        }

        var token = readToken(forceRegexp);

        overallContent.lastToken = token;
        loadedContent.processedTokenCounter++;

        return token;
    }

    // sort of obsolete with changes to no longer store whole overallContent.content
    function jumpTo(pos, reAllowed) {
        loadedContent.Position = pos;

        flags.tokRegexpAllowed = reAllowed;
        skipSpace();
    }

    function getIndent() {
        return indentStack.count();
    }

    // #endregion

    // #region private functions

    function loadNextLineWithoutResetting() {
        var previousState = flags.isMultilineProcessing;

        flags.isMultilineProcessing = true;
        loadNextLine();
        flags.isMultilineProcessing = previousState;
    }

    function createStringReadFunc(str) {
        var lines = str
            ? str.split(/\r?\n/).reverse().map(function (l) { return l + "\n"; })
            : [];

        return function () {
            if (lines.length === 0) {
                flags.isEOF = true;
                return undefined;
            }

            return updateLoadedState(lines.pop());
        };
    }

    function wrapStringReadFunc(func) {
        return function () {
            var line;
            try {
                line = func();
                if (!line) {
                    flags.isEOF = true;
                    return undefined;
                }
            } catch (exception) {
                flags.isEOF = true;
                return undefined;
            }

            line = line.replace(/[\r|\n|\r\n]$/, '\n');
            return updateLoadedState(line);
        };
    }

    function updateLoadedState(line) {
        if (!flags.isMultilineProcessing) {
            resetContent();
        }

        loadedContent.currentLine = line;
        loadedContent.inputLen += loadedContent.currentLine.length;

        overallContent.content += loadedContent.currentLine;
        overallContent.totalLen += loadedContent.inputLen;
        overallContent.currentLineNumber++;

        // skip empty new lines (unless its multiline processing case)
        if (!flags.isMultilineProcessing && isEmptyLine(line)) {
            return loadNextLine();
        }

        return loadedContent.currentLine;
    }

    // reset overallContent.content and relevant state parameters to no longer keep track of already processed data
    function resetContent() {
        loadedContent.inputLen = 0;
        loadedContent.Position = 0;
        loadedContent.processedTokenCounter = 0;

        currentTokenInformation.tokType = _newline;

        overallContent.content = "";
    }

    function skipAndReadNext() {
        // some tokens read already, can't go to the next line, need to handle new line and/or eof
        // unless it is nested with brackets, then read from next line without new line token
        if (overallContent.bracketNesting === 0
            && (loadedContent.processedTokenCounter > 0 || flags.isEOF)) {
            return readFromEndOfLine();
        }

        // empty line or only comments - ignore and move to next line
        return readFromStartOfNewLine();
    }

    function readFromEndOfLine() {
        loadedContent.Position = overallContent.content.length - 1;
        currentTokenInformation.tokType = null;

        return readToken();
    }

    function readFromStartOfNewLine() {
        loadNextLine();

        return readToken();
    }

    function isEndOfLine(position) {
        position = position || loadedContent.Position;

        return overallContent.content.length <= position;
    }

    // true if line contains only "new line" symbol (without EndOfFile)
    function isEmptyLine(line) {
        return line
            && line.length === 1
            && isNewline(line.charCodeAt(0));
    }

    // get specified overallContent.content character ascii code
    function peek(position) {
        position = position || loadedContent.Position;
        if (isEndOfLine(position)) {
            return NaN;
        }

        return overallContent.content.charCodeAt(position);
    }

    function raise(pos, message) {
        var err = new SyntaxError(message);
        err.pos = getOverallPosition(pos);
        err.raisedAt = getOverallPosition(currentTokenInformation.tokStart);

        throw err;
    }

    /* At this point token end is found. Create and return result token object.
       After each token finalization, clean up is performed to skip unnecessary symbols,
       (like comments, spaces, etc)
       so that the tokenizer would start from the correct position with next token.*/
    function finishToken(type, val) {
        setTokenEndLocation();
        currentTokenInformation.tokType = type;

        if (type === _parenL || type === _braceL || type === _bracketL) {
            ++overallContent.bracketNesting;
        }

        if (type === _parenR || type === _braceR || type === _bracketR) {
            --overallContent.bracketNesting;
        }

        if (type !== _newline) {
            skipSpace();
        }

        if (val === undefined && type && type.type) {
            val = type.type;
        }

        flags.tokRegexpAllowed = type.beforeExpr;

        return getTokenResult(val);
    }

    function getTokenResult(val) {
        return {
            start: currentTokenInformation.tokStart,
            end: currentTokenInformation.tokEnd,
            startLoc: currentTokenInformation.tokStartLoc,
            endLoc: currentTokenInformation.tokEndLoc,
            type: currentTokenInformation.tokType,
            value: val,
            line: loadedContent.currentLine
        };
    }

    function setTokenStartLocation() {
        currentTokenInformation.tokStart = getOverallPosition(loadedContent.Position);

        currentTokenInformation.tokStartLoc = new Position;
    }

    function setTokenEndLocation() {
        currentTokenInformation.tokEnd = getOverallPosition(loadedContent.Position);

        currentTokenInformation.tokEndLoc = new Position();
    }

    function getOverallPosition(pos) {
        pos = pos || loadedContent.Position;

        // total length read already - length of current line + current line position
        return overallContent.totalLen - loadedContent.inputLen + pos;
    }

    // Test whether a given character code starts an identifier.
    function isIdentifierStart(code) {
        if (code < ASCII_CODES.UPPERCASE_A) {
            return code === ASCII_CODES.DOLLAR;
        }

        if (code < ASCII_CODES.LEFT_BRACKET) {
            return true;
        }

        if (code < ASCII_CODES.LOWERCASE_A) {
            return code === ASCII_CODES.UNDER_SCORE;
        }

        if (code < ASCII_CODES.LEFT_BRACE) {
            return true;
        }

        return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
    }

    // Test whether a given character is part of an identifier.
    function isIdentifierChar(code) {
        if (code < ASCII_CODES.ZERO) {
            return code === ASCII_CODES.DOLLAR;
        }

        if (code < ASCII_CODES.COLON) {
            return true;
        }

        if (code < ASCII_CODES.UPPERCASE_A) {
            return false;
        }

        if (code < ASCII_CODES.LEFT_BRACKET) {
            return true;
        }

        if (code < ASCII_CODES.LOWERCASE_A) {
            return code === ASCII_CODES.UNDER_SCORE;
        }

        if (code < ASCII_CODES.LEFT_BRACE) {
            return true;
        }

        return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
    }

    function isSpace(ch) {
        if (ch === ASCII_CODES.SPACE ||
            ch === ASCII_CODES.TAB ||
            ch === ASCII_CODES.VERTICAL_TAB ||
            ch === ASCII_CODES.NEW_PAGE ||
            ch === 160 || // '\xa0'
            (ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch)))) {
            return true;
        }

        return false;
    }

    function isNewline(ch) {
        if (ch === ASCII_CODES.NEW_LINE ||
            ch === ASCII_CODES.CARRIAGE_RETURN ||
            ch === 8232 ||
            ch === 8233) {
            return true;
        }

        return false;
    }

    // Called at the start of the parse and after every token. Skips whitespace and comments.
    function skipSpace() {
        while (!isEndOfLine()) {
            var ch = peek(loadedContent.Position);
            if (ch === ASCII_CODES.BACKSLASH) {
                skipLineContinue();
            } else if (isSpace(ch)) {
                ++loadedContent.Position;
            } else if (overallContent.bracketNesting > 0 && isNewline(ch)) {
                skipBracketNestedNewline(ch);
            } else {
                break;
            };
        }
    }

    // for multiline token cases including backslash - go to next line whilst keeping information of previous read lines
    function skipLineContinue() {
        var charCode = peek(++loadedContent.Position);

        if (!isNewline(charCode)) {
            raise(loadedContent.Position, "Unexpected character after line continuation character");
        }

        if (charCode === ASCII_CODES.CARRIAGE_RETURN && peek(loadedContent.Position + 1) === ASCII_CODES.NEW_LINE) {
            ++loadedContent.Position;
        }

        ++loadedContent.Position;

        loadNextLineWithoutResetting();
    }

    // for multiline token cases including brackets
    function skipBracketNestedNewline(ch) {
        if (ch === ASCII_CODES.CARRIAGE_RETURN && peek(loadedContent.Position + 1) === ASCII_CODES.NEW_LINE) {
            ++loadedContent.Position;
        }

        ++loadedContent.Position;
    }

    // used for the `currentTokenInformation.tokStartLoc` and `currentTokenInformation.tokEndLoc` properties.
    function Position() {
        this.line = overallContent.currentLineNumber;
        this.column = loadedContent.Position;
    }

    // ### Token reading

    function readToken_dot() {
        var next = peek(loadedContent.Position + 1);
        if (next >= ASCII_CODES.ZERO && next <= ASCII_CODES.NINE) {
            return readNumber(true);
        }

        ++loadedContent.Position;
        return finishToken(_dot);
    }

    function readToken_eta() {
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_eta, 2);
        }

        ++loadedContent.Position;
        return finishToken(_eta);
    }

    // /, //, /=, //=
    function readToken_slash() {
        if (flags.tokRegexpAllowed) {
            ++loadedContent.Position;
            return readRegexp();
        }

        var next1 = peek(loadedContent.Position + 1);
        if (next1 === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        if (next1 === ASCII_CODES.FORWARD_SLASH) {
            var next2 = peek(loadedContent.Position + 2);
            if (next2 === ASCII_CODES.EQUAL) {
                return finishOp(_assign, 3);
            }

            return finishOp(_floorDiv, 2);
        }

        return finishOp(_slash, 1);
    }

    // %, %=
    function readToken_Percentage() {
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        return finishOp(_multiplyModulo, 1);
    }

    // *, **, *=, **=
    function readToken_Asterisk() {
        var next1 = peek(loadedContent.Position + 1);

        if (next1 === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        if (next1 === ASCII_CODES.ASTERISK) {
            var next2 = peek(loadedContent.Position + 2);
            if (next2 === ASCII_CODES.EQUAL) {
                return finishOp(_exponentiation, 3);
            }

            return finishOp(_exponentiation, 2);
        }


        return finishOp(_multiplyModulo, 1);
    }

    function readToken_pipe_amp(code) { // '|&'
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        return finishOp(code === ASCII_CODES.VERTICAL_LINE ? _bitwiseOR : _bitwiseAND, 1);
    }

    function readToken_caret() { // '^'
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        return finishOp(_bitwiseXOR, 1);
    }

    function readToken_plus_min() { // '+-'
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_assign, 2);
        }

        return finishOp(_plusMin, 1);
    }

    function readToken_lt_gt(code) { // '<>'
        var next = peek(loadedContent.Position + 1);
        var size = 1;

        if (next === code) {
            size = 2;
            if (peek(loadedContent.Position + size) === ASCII_CODES.EQUAL) {
                return finishOp(_assign, size + 1);
            }

            return finishOp(_bitShift, size);
        }

        if (next === ASCII_CODES.EQUAL) {
            size = 2;
        }

        return finishOp(_relational, size);
    }

    function readToken_eq_excl() { // '=!'
        var next = peek(loadedContent.Position + 1);
        if (next === ASCII_CODES.EQUAL) {
            return finishOp(_equality, 2);
        }

        return finishOp(_eq, 1);
    }

    // Read indent, skip empty lines and comments
    function readIndent() {
        var indent = {
            str: "",
            pos: loadedContent.Position,
            isSkipped: false
        };

        while (!isEndOfLine(indent.pos)) {
            var ch = peek(indent.pos);

            if (isSpace(ch)) {
                indent.str += String.fromCharCode(ch);
                ++indent.pos;
                continue;
            }

            // end of line or a comment - ignore
            if (isNewline(ch) || ch === ASCII_CODES.HASH) {
                break;
            }

            return indent; // some source code found!
        }

        // ok, this wasn't an actual indent.
        // skip and read next token
        if (indent.str.trim().length === 0 || 
            peek(loadedContent.Position) === ASCII_CODES.HASH) {
            indent.isSkipped = true;
        }

        return indent;
    }

    function analyzeIndent(indent, indentHist) {
        if (indent.isSkipped) {
            // if indent was skipped (processing moved to next line), change type to new line
            return _newline;
        }

        if (overallContent.bracketNesting > 0) {
            loadedContent.Position += indent.str.length;
            return null;
        }

        if (indent.str.length > 0) {
            if (indentHist.isIndent(indent.str)) {
                if (indentHist.count() >= 1) {
                    currentTokenInformation.tokStart += indentHist.len(indentHist.count() - 1);
                }
                indentHist.addIndent(indent.str);

                return _indent;
            }

            if (indentHist.isDedent(indent.str)) {
                indentHist.addDedent(indent.str);
                var nextDedent = indentHist.count() - indentHist.dedentCount;

                if (nextDedent >= 2) {
                    currentTokenInformation.tokStart += indentHist.len(nextDedent) - indentHist.len(nextDedent - 1);
                }

                return _dedent;
            }
            loadedContent.Position += indent.str.length;

            return null;
        }

        if (indentHist.count() > 0) {
            indentHist.updateDedent();

            return _dedent;
        }

        return null;
    }

    // Parse indentation
    // Possible output: _indent, _dedent, _eof, readToken()
    // TODO: disallow unequal indents of same length (e.g. nested if/else block)
    function readToken_indent() {
        var indent = readIndent();
        var type = analyzeIndent(indent, indentStack);

        switch (type) {
            case _indent:
            case _dedent:
                return finishOp(type, indent.pos - ++loadedContent.Position);
            case _eof:
                loadedContent.Position = loadedContent.inputLen;
                currentTokenInformation.tokStartLoc = new Position;
                return finishOp(type, 0);
            case _newline:
                return skipAndReadNext();
            default:
                currentTokenInformation.tokType = null;
                return readToken();
        }
    }

    function getTokenFromCode(code) {
        switch (code) {
            case ASCII_CODES.NEW_LINE:
            case ASCII_CODES.CARRIAGE_RETURN:
            case 8232:
            case 8233:
                ++loadedContent.Position;
                if (code === ASCII_CODES.CARRIAGE_RETURN && peek(loadedContent.Position) === ASCII_CODES.NEW_LINE) {
                    ++loadedContent.Position;
                }

                return finishToken(_newline);

            case ASCII_CODES.HASH:
                // read up to end of line
                return skipAndReadNext();

            // The interpretation of a dot depends on whether it is followed
            // by a digit.
            case ASCII_CODES.DOT:
                return readToken_dot();

            case ASCII_CODES.AT:
                return readToken_eta();

            // Punctuation tokens.
            case ASCII_CODES.LEFT_PARENTHESIS:
                ++loadedContent.Position;
                return finishToken(_parenL);

            case ASCII_CODES.RIGHT_PARENTHESIS:
                ++loadedContent.Position;
                return finishToken(_parenR);

            case ASCII_CODES.SEMI_COLON:
                ++loadedContent.Position;
                return finishToken(_semi);

            case ASCII_CODES.COMMA:
                ++loadedContent.Position;
                return finishToken(_comma);

            case ASCII_CODES.LEFT_BRACKET:
                ++loadedContent.Position;
                return finishToken(_bracketL);

            case ASCII_CODES.RIGHT_BRACKET:
                ++loadedContent.Position;
                return finishToken(_bracketR);

            case ASCII_CODES.LEFT_BRACE:
                ++loadedContent.Position;
                return finishToken(_braceL);

            case ASCII_CODES.RIGHT_BRACE:
                ++loadedContent.Position;
                return finishToken(_braceR);

            case ASCII_CODES.COLON:
                ++loadedContent.Position;
                return finishToken(_colon);

            case ASCII_CODES.QUESTION_MARK:
                ++loadedContent.Position;
                return finishToken(_question);

            // '0x' is a hexadecimal number , '0o' is octal and '0b' is binary
            case ASCII_CODES.ZERO:
                var next = peek(loadedContent.Position + 1);
                if (next === ASCII_CODES.LOWERCASE_X ||
                    next === ASCII_CODES.UPPERCASE_X ||
                    next === ASCII_CODES.LOWERCASE_O ||
                    next === ASCII_CODES.UPPERCASE_O ||
                    next === ASCII_CODES.LOWERCASE_B ||
                    next === ASCII_CODES.UPPERCASE_B) {
                    return readZeroXNumber(code, next);
                }

            // Anything else beginning with a digit is an integer, octal
            // number, or float.
            case ASCII_CODES.ONE:
            case ASCII_CODES.TWO:
            case ASCII_CODES.THREE:
            case ASCII_CODES.FOUR:
            case ASCII_CODES.FIVE:
            case ASCII_CODES.SIX:
            case ASCII_CODES.SEVEN:
            case ASCII_CODES.EIGHT:
            case ASCII_CODES.NINE:
                return readNumber(false);

            // Quotes produce strings.
            case ASCII_CODES.DOUBLE_QUOTE:
            case ASCII_CODES.SINGLE_QUOTE:
                return readString(code);

            // Operators are parsed inline in tiny state machines. '=' (61) is
            // often referred to. `finishOp` simply skips the amount of
            // characters it is given as second argument, and returns a token
            // of the type given by its first argument.
            case ASCII_CODES.FORWARD_SLASH:
                return readToken_slash(code);

            case ASCII_CODES.ASTERISK:
                return readToken_Asterisk();

            case ASCII_CODES.PERCENTAGE:
                return readToken_Percentage();

            case ASCII_CODES.VERTICAL_LINE:
            case ASCII_CODES.AMPERSAND:
                return readToken_pipe_amp(code);

            case ASCII_CODES.CARET:
                return readToken_caret();

            case ASCII_CODES.PLUS:
            case ASCII_CODES.MINUS:
                return readToken_plus_min(code);

            case ASCII_CODES.LESS_THAN:
            case ASCII_CODES.GREATER_THAN:
                return readToken_lt_gt(code);

            case ASCII_CODES.EQUAL:
            case ASCII_CODES.EXCLAMATION_POINT:
                return readToken_eq_excl(code);

            case ASCII_CODES.TILDE:
                return finishOp(_bitwiseNOT, 1);
        }

        return false;
    }

    function readToken(forceRegexp) {
        if (currentTokenInformation.tokType === _dedent) {
            indentStack.pop();
            if (indentStack.dedentCount > 0) {
                return overallContent.lastToken;
            }
        }

        if (forceRegexp) {
            loadedContent.Position = currentTokenInformation.tokStart + 1;
            return readRegexp();
        } else {
            setTokenStartLocation();
        }

        if (currentTokenInformation.tokType === _newline) {
            return readToken_indent();
        }

        if (flags.isEOF) {
            return finishToken(_eof);
        }

        var code = peek(loadedContent.Position);
        if (isQuote(code)) {
            return readString(code);
        }

        // Identifier or keyword. '\uXXXX' sequences are allowed in
        // identifiers, so '\' also dispatches to that.
        if (isIdentifierStart(code) || code === ASCII_CODES.BACKSLASH) {
            return readWord();
        }

        var tok = getTokenFromCode(code);
        if (tok !== false) {
            return tok;
        }

        // If we are here, we either found a non-ASCII identifier
        // character, or something that's entirely disallowed.
        var ch = String.fromCharCode(code);
        if (ch === "\\" || nonASCIIidentifierStart.test(ch)) {
            return readWord();
        }

        return raise(loadedContent.Position, "Unexpected character '" + ch + "'");
    }

    function finishOp(type, size) {
        var str = overallContent.content.slice(loadedContent.Position, loadedContent.Position + size);
        loadedContent.Position += size;

        return finishToken(type, str);
    }

    // Parse a regular expression. Some context-awareness is necessary,
    // since a '/' inside a '[]' set does not end the expression.
    function readRegexp() {
        var fragment = "", escaped, inClass, start = loadedContent.Position, value;
        for (; ;) {
            if (isEndOfLine(loadedContent.Position)) {
                raise(start, "Unterminated regular expression");
            }

            var ch = overallContent.content.charAt(loadedContent.Position);
            if (newline.test(ch)) {
                raise(start, "Unterminated regular expression");
            }

            if (!escaped) {
                if (ch === "[") {
                    inClass = true;
                } else if (ch === "]" && inClass) {
                    inClass = false;
                } else if (ch === "/" && !inClass) {
                    break;
                }

                escaped = ch === "\\";
            } else {
                escaped = false;
            }

            ++loadedContent.Position;
        }
        fragment = overallContent.content.slice(start, loadedContent.Position);
        ++loadedContent.Position;

        // Need to use `readWord1` because '\uXXXX' sequences are allowed
        // here (don't ask).
        var mods = readWord1();
        if (mods && !/^[gmsiy]*$/.test(mods)) {
            raise(start, "Invalid regular expression flag");
        }

        try {
            value = new RegExp(fragment, mods);
        } catch (e) {
            if (e instanceof SyntaxError) {
                raise(start, "Error parsing regular expression: " + e.message);
            }

            raise(e);
        }

        return finishToken(_regexp, value);
    }

    // Read an integer in the given radix. Return null if zero digits
    // were read, the integer value otherwise. When `len` is given, this
    // will return `null` unless the integer has exactly `len` digits.
    function readInt(radix, len) {
        var start = loadedContent.Position;
        var i = 0;
        var e = ((len == null) ? Infinity : len);
        var strVal = "";
        for (; i < e; ++i) {
            var code = peek(loadedContent.Position);
            var val = 0;

            if (code === ASCII_CODES.UNDER_SCORE) { // underscore , a grouping symbol - allowed
                ++loadedContent.Position;
                continue;
            }

            if (code >= ASCII_CODES.LOWERCASE_A) {
                val = code - ASCII_CODES.LOWERCASE_A + ASCII_CODES.NEW_LINE; // a
            } else if (code >= ASCII_CODES.UPPERCASE_A) {
                val = code - ASCII_CODES.UPPERCASE_A + ASCII_CODES.NEW_LINE; // A
            } else if (code >= ASCII_CODES.ZERO && code <= ASCII_CODES.NINE) {
                val = code - ASCII_CODES.ZERO; // 0-9
            } else {
                val = Infinity;
            }

            if (val >= radix) {
                break;
            }

            strVal += String.fromCharCode(code);
            ++loadedContent.Position;
        }

        if (loadedContent.Position === start ||
            (len != null && (loadedContent.Position - start !== len))) {
            return null;
        }

        return strVal;
    }

    function readZeroXNumber(first, second) {
        loadedContent.Position += 2; // 0x

        var val = readInt(16);

        if (val == null) {
            raise(loadedContent.Position, "Expected hexadecimal number");
        }

        var next = peek(loadedContent.Position);
        if (next === ASCII_CODES.LOWERCASE_J ||
            next === ASCII_CODES.UPPERCASE_J || // 'j' or 'J' is imaginary number
            next === ASCII_CODES.UPPERCASE_L) { // 'L' is for backward compatibility with Python 2.x spec
            val = val + String.fromCharCode(next);
            loadedContent.Position++;
        }

        if (isIdentifierStart()) {
            raise(loadedContent.Position, "Identifier directly after number");
        }

        val = String.fromCharCode(first)
            + String.fromCharCode(second)
            + val;

        return finishToken(_num, val);
    }

    function readNumber(startsWithDot) {
        var start = loadedContent.Position;

        if (!startsWithDot && readInt(10) === null) {
            raise(start, "Invalid number");
        }

        if (peek(loadedContent.Position) === ASCII_CODES.DOT) {
            ++loadedContent.Position;
            readInt(10);
        }

        var next = peek(loadedContent.Position);
        if (next === ASCII_CODES.UPPERCASE_E || next === ASCII_CODES.LOWERCASE_E) { // 'eE'
            next = peek(++loadedContent.Position);

            if (next === ASCII_CODES.PLUS || next === ASCII_CODES.MINUS) {
                ++loadedContent.Position; // '+-'
            }

            if (readInt(10) === null) {
                raise(start, "Invalid number");
            }
        }

        next = peek(loadedContent.Position);
        if (next === ASCII_CODES.LOWERCASE_J ||
            next === ASCII_CODES.UPPERCASE_J || // 'j' or 'J' is imaginary number
            next === ASCII_CODES.UPPERCASE_L) { // 'L' is for passing tests of python 2.x
            loadedContent.Position++;
        }

        if (isIdentifierStart(peek(loadedContent.Position))) {
            raise(loadedContent.Position, "Identifier directly after number");
        }

        var str = overallContent.content.slice(start, loadedContent.Position);

        return finishToken(_num, str);
    }

    function isQuote(currentChar) {
        if (isQuoteSymbol(currentChar)) {
            return true;
        }

        var next1 = peek(loadedContent.Position + 1);
        var next2 = peek(loadedContent.Position + 2);

        switch (currentChar) {
            case ASCII_CODES.LOWERCASE_U:
            case ASCII_CODES.UPPERCASE_U:
                return isQuoteSymbol(next1);

            case ASCII_CODES.LOWERCASE_R:
            case ASCII_CODES.UPPERCASE_R:
                return isQuoteSymbol(next1) ||
                    ((next1 === ASCII_CODES.LOWERCASE_F || next1 === ASCII_CODES.UPPERCASE_F) && isQuoteSymbol(next2));

            case ASCII_CODES.LOWERCASE_F:
            case ASCII_CODES.UPPERCASE_F:
                return isQuoteSymbol(next1) ||
                    ((next1 === ASCII_CODES.LOWERCASE_R || next1 === ASCII_CODES.UPPERCASE_R) && isQuoteSymbol(next2));
        }

        return false;
    }

    function isQuoteSymbol(char) {
        return char === ASCII_CODES.DOUBLE_QUOTE || char === ASCII_CODES.SINGLE_QUOTE;
    }

    function readStringBegin(currentChar) {
        loadedContent.Position++;
        var nextChar = peek(loadedContent.Position);
        if (isQuoteSymbol(currentChar)) {
            return readQuoteBegin(currentChar, nextChar);
        }

        switch (currentChar) {
            case ASCII_CODES.LOWERCASE_R:
            case ASCII_CODES.UPPERCASE_R:
            case ASCII_CODES.LOWERCASE_U:
            case ASCII_CODES.UPPERCASE_U:
            case ASCII_CODES.LOWERCASE_F:
            case ASCII_CODES.UPPERCASE_F:
                return readStringBegin(nextChar);
        }

        raise(currentTokenInformation.tokStart, "not a string start");
    }

    function readQuoteBegin(prevChar, currentChar) {
        if (prevChar !== currentChar) {
            return [prevChar]; // singleQuote
        }

        var nextChar = peek(loadedContent.Position + 1);
        if (nextChar !== currentChar) {
            return [prevChar]; // double quote
        }

        loadedContent.Position += 2;
        return [prevChar, currentChar, nextChar]; // triple quote
    }

    function readString(ch) {
        var strStartPos = loadedContent.Position;
        var quote = readStringBegin(ch);
        if (!quote || !quote.length) {
            throw "invalid string";
        }

        var tripleQuoted = (quote.length === 3);
        var quoteChar = quote[0];

        if (tripleQuoted) {
            return readMultiLineString(strStartPos, ch, quoteChar);
        }

        for (; ;) {
            if (flags.isEOF) {
                raise(currentTokenInformation.tokStart, "Unterminated string constant");
            }

            ch = peek(loadedContent.Position);
            ++loadedContent.Position;

            if (ch === quoteChar) {
                return finishToken(_string, overallContent.content.slice(strStartPos, loadedContent.Position));
            }

            if (ch === ASCII_CODES.BACKSLASH) {   // '\'
                var nextCh = peek(loadedContent.Position);

                // can it be quotes escaped ?
                switch (nextCh) {
                    case ASCII_CODES.DOUBLE_QUOTE:
                    case ASCII_CODES.SINGLE_QUOTE: // single or double quotes escaped
                        loadedContent.Position += 1;
                        break;
                    case ASCII_CODES.BACKSLASH: // backslash symbol escaped
                        loadedContent.Position += 1;
                        break;
                }

                // can it be a line break ?
                while (isSpace(nextCh)) {
                    nextCh = peek(++loadedContent.Position);
                }

                if (nextCh === ASCII_CODES.NEW_LINE) { // unix newline is permitted
                    loadedContent.Position++;
                    loadNextLineWithoutResetting();
                } else if (nextCh === ASCII_CODES.CARRIAGE_RETURN && peek(loadedContent.Position + 1) === ASCII_CODES.NEW_LINE) { // windows newline is also permitted 
                    loadedContent.Position += 2;
                    loadNextLineWithoutResetting();
                }

                continue;
            }

            if (isNewline(ch)) {
                raise(currentTokenInformation.tokStart, "Unterminated string constant");
            }
        }

    }

    // special handling for multiline strings
    function readMultiLineString(strStartPos, ch, quoteChar) {
        flags.isMultilineProcessing = true;

        for (; ;) {
            if (flags.isEOF) {
                raise(currentTokenInformation.tokStart, "Unterminated string constant");
            }

            ch = peek(loadedContent.Position);
            ++loadedContent.Position;

            if (ch === quoteChar) {
                if (peek(loadedContent.Position) === quoteChar && peek(loadedContent.Position + 1) === quoteChar) {
                    flags.isMultilineProcessing = false;
                    loadedContent.Position += 2;
                    return finishToken(_string, overallContent.content.slice(strStartPos, loadedContent.Position));
                }

                continue;
            }

            if (isNewline(ch)) {
                if (ch === ASCII_CODES.CARRIAGE_RETURN && peek(loadedContent.Position) === ASCII_CODES.NEW_LINE) { // windows newline is 2 symbols
                    ++loadedContent.Position;
                }

                loadNextLine();
            }
        }
    }

    function readHexChar(len) {
        var n = readInt(16, len);
        if (n === null) {
            raise(currentTokenInformation.tokStart, "Bad character escape sequence");
        }

        return n;
    }

    // Read an identifier, and return it as a string. Sets `flags.containsEsc`
    // to whether the word contained a '\u' escape.
    //
    // Only builds up the word character-by-character when it actually
    // contains an escape, as a micro-optimization.

    function readWord1() {
        flags.containsEsc = false;
        var word = "", first = true, start = loadedContent.Position;
        for (; ;) {
            var ch = peek(loadedContent.Position);
            if (isIdentifierChar(ch)) {
                if (flags.containsEsc) {
                    word += overallContent.content.charAt(loadedContent.Position);
                }

                ++loadedContent.Position;
            } else {
                if (ch === ASCII_CODES.BACKSLASH) {
                    if (!flags.containsEsc) {
                        word = overallContent.content.slice(start, loadedContent.Position);
                    }

                    flags.containsEsc = true;
                    if (peek(++loadedContent.Position) !== ASCII_CODES.LOWERCASE_U) { // "u"
                        raise(loadedContent.Position, "Expecting Unicode escape sequence \\uXXXX");
                    }

                    ++loadedContent.Position;
                    var esc = readHexChar(4);
                    var escStr = String.fromCharCode(esc);
                    if (!escStr) {
                        raise(loadedContent.Position - 1, "Invalid Unicode escape");
                    }

                    if (!(first ? isIdentifierStart(esc) : isIdentifierChar(esc))) {
                        raise(loadedContent.Position - 4, "Invalid Unicode escape");
                    }

                    word += escStr;
                } else {
                    break;
                }
            }
            first = false;
        }

        return flags.containsEsc
            ? word
            : overallContent.content.slice(start, loadedContent.Position);
    }

    // Read an identifier or keyword token. Will check for reserved
    // words when necessary.
    function readWord() {
        var word = readWord1();
        var type = _name;

        return finishToken(type, word);
    }

    function isFunction(obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    }

    // #endregion
};

Sk.exportSymbol("Sk.Tokenizer", Sk.Tokenizer);